import styled from 'styled-components'

export const ContainerUserAvatar = styled.a`
  margin-right: 8px;
`
